import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableCellBase } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-cell-base';

@Component({
    selector: 'fi-wrapper-table-super-admin-icon-cell',
    template: ` @if (value) {
        <mat-icon class="far fa-shield-check" />
    }`,
    styleUrls: ['./fi-wrapper-table-super-admin-icon-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-wrapper-table-super-admin-icon-cell' },
    standalone: false,
})
export class FiWrapperTableSuperAdminIconCellComponent extends FiWrapperTableCellBase<boolean> {}
